import { Box, Grid, Typography } from '@mui/material';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { DropzoneField } from 'src/components/forms/DropzoneField';
import { FilePutFields } from '../api/file-fields';
import { ArchivoFormData } from './DialogNuevoArchivo';
import { SectionBox } from './FieldView';
import CardActions from './CardActions';


interface SeccionNuevoArchivoProps {
  formMethods: UseFormReturn<any>
}

const SeccionNuevoArchivo = ({ formMethods }: SeccionNuevoArchivoProps) => {
  const { control, setValue, resetField } = formMethods

  const watchArchivo = useWatch({
    control,
    name: FilePutFields.File
  });

  return (
    <CardActions title='Documentación respaldatoria' icon='mdi:paperclip' colapsable>
      <SectionBox>
        <Grid item xs={12}>
          <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
            Si la operación requiere documentación respaldatoria, adjúntela aquí:
          </Typography>
          <Box sx={{ minHeight: '100px' }}>
            {watchArchivo ? (
              <ArchivoFormData
                archivo={watchArchivo}
                onRemove={() => resetField(FilePutFields.File)}
              />
            ) : (
              <DropzoneField
                name={FilePutFields.File}
                control={control}
                setValue={setValue}
              />
            )}
          </Box>
        </Grid>
      </SectionBox>
    </CardActions>
  )
}

export default SeccionNuevoArchivo
